import { z } from "zod"

import { entityIdSchema } from "./identifiers.js"

const timestamp = z.string().datetime({ offset: false })

export const savedPaymentMethodRegisterV1Schema = z.object({
  savedMethodId: entityIdSchema,
  billingProfileId: entityIdSchema,
  providerPaymentMethodId: z.string().regex(/^pm_[A-Za-z0-9_]{3,128}$/),
  consentTextVersion: z.string().trim().min(1).max(64),
  consentedAt: timestamp,
  autopayAuthorized: z.boolean(),
}).strict()

export const invoicePaymentBeginV1Schema = z.object({
  paymentAttemptId: entityIdSchema,
  invoiceId: entityIdSchema,
  paymentPath: z.enum(["hosted", "autopay"]),
  savedMethodId: entityIdSchema.nullable(),
  policyDecisionId: entityIdSchema,
  saveForFuture: z.boolean(),
  consentTextVersion: z.string().trim().min(1).max(64).nullable(),
  consentedAt: timestamp.nullable(),
  statusLinkId: entityIdSchema,
  statusLinkTokenHash: z.string().regex(/^[a-f0-9]{64}$/),
}).strict().superRefine((value, context) => {
  if (value.paymentPath === "autopay" && value.savedMethodId === null) {
    context.addIssue({ code: "custom", message: "Saved method required." })
  }
  if (value.saveForFuture && (
    value.consentTextVersion === null || value.consentedAt === null
  )) context.addIssue({ code: "custom", message: "Consent required." })
})

export type SavedPaymentMethodRegisterV1 = z.infer<
  typeof savedPaymentMethodRegisterV1Schema
>
export type InvoicePaymentBeginV1 = z.infer<typeof invoicePaymentBeginV1Schema>
